import { createSelector } from '@reduxjs/toolkit';

import { RootState } from 'types';
import { initialState } from '.';

const selectSlice = (state: RootState) => state?.menu || initialState;

export const selectMenu = createSelector([selectSlice], state => state);
export const selectMenuSiteTitle = createSelector([selectSlice], state => ({
  siteTitle: state.siteTitle,
}));

export const selectMenuTabs = createSelector([selectSlice], state => ({
  tabs: state.tabs,
}));
